export const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'flagged', label: 'Flagged' },
  { key: 'blurry', label: 'Blurry' },
  { key: 'eyes', label: 'Eyes closed' },
  { key: 'posing', label: 'Posing' },
  { key: 'duplicates', label: 'Duplicates' },
  { key: 'hidden', label: 'Hidden' },
  { key: 'clean', label: 'Clean' },
];

export const isFlagged = (img) => {
  const c = img.cull || {};
  return Boolean(c.blurry || c.eyes_closed || c.expression_issue || c.posing_issue || c.duplicate_group);
};

export const matchesFilter = (img, filter) => {
  const c = img.cull || {};
  switch (filter) {
    case 'flagged': return isFlagged(img);
    case 'blurry': return Boolean(c.blurry);
    case 'eyes': return Boolean(c.eyes_closed || c.expression_issue);
    case 'posing': return Boolean(c.posing_issue);
    case 'duplicates': return Boolean(c.duplicate_group);
    case 'hidden': return Boolean(img.hidden);
    case 'clean': return c.analyzed && !isFlagged(img) && !img.hidden;
    default: return true;
  }
};

export const thumbUrl = (img) => img.variants?.social || img.variants?.web || img.image_url;
export const fullUrl = (img) => img.variants?.web || img.image_url;

export const displayName = (img, index) => img.original_filename || img.caption || `Photo ${index + 1}`;

export const sortImages = (images, sort) => {
  const list = [...images];
  if (sort === 'sharpness_asc') list.sort((a, b) => (a.cull?.sharpness ?? Infinity) - (b.cull?.sharpness ?? Infinity));
  else if (sort === 'sharpness_desc') list.sort((a, b) => (b.cull?.sharpness ?? -1) - (a.cull?.sharpness ?? -1));
  else if (sort === 'flagged') list.sort((a, b) => Number(isFlagged(b)) - Number(isFlagged(a)));
  return list;
};
